// American University's undergraduate majors (#2652, batch 2). Read on
// 2026-10-01 from the official University Catalog 2026-2027, Major Program
// (UG) list (catalog.american.edu, catoid=23 navoid=4419), read in a headless
// browser. One list, no schools. A major listed twice for two academic units
// (tags like [CAS/WLC] and [SOC]) or with both a BA and a BS appears once.
// Left out: Secondary Education (Second Major Only). Flags quote AU's
// first-year application checklist (the college file's `checklist`).
const majors = {
    "slug": "american-university",
    "read": "2026-10-01",
    "intro": "Every undergraduate major in AU's official 2026-2027 University Catalog, with the degree it leads to. The catalog lists majors in one list, not by school. Minors, certificates and second-major-only programs are left out.",
    "groups": [
        {
            "name": "Undergraduate majors",
            "source": {
                "label": "AU University Catalog 2026-2027, Major Program (UG)",
                "url": "https://catalog.american.edu/content.php?catoid=23&navoid=4419"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS"
                },
                {
                    "name": "African American and African Diaspora Studies",
                    "degree": "BA"
                },
                {
                    "name": "American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Applied Public Policy Analysis",
                    "degree": "BA",
                    "note": "Accelerated"
                },
                {
                    "name": "Arab World Studies",
                    "degree": "BA"
                },
                {
                    "name": "Arabic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Asia, Pacific, and Diaspora Studies",
                    "degree": "BA"
                },
                {
                    "name": "Audio Production",
                    "degree": "BA"
                },
                {
                    "name": "Audio Technology",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration",
                    "degree": "BSBA"
                },
                {
                    "name": "Business Analytics and Artificial Intelligence",
                    "degree": "BS"
                },
                {
                    "name": "Business and Entertainment",
                    "degree": "BS"
                },
                {
                    "name": "Business, Language & Culture Studies",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chinese Studies",
                    "degree": "BA"
                },
                {
                    "name": "Communication, Language, and Culture",
                    "degree": "BA",
                    "note": "Offered through CAS/WLC and SOC"
                },
                {
                    "name": "Communication: Communication Studies",
                    "degree": "BA"
                },
                {
                    "name": "Communication: Film and Media Arts",
                    "degree": "BA"
                },
                {
                    "name": "Communication: Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Computational Media and Applied Perception",
                    "degree": "BA"
                },
                {
                    "name": "Computational Science",
                    "degree": "BS",
                    "note": "Offered through CAS/CSC and CAS/MATH"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA or BS"
                },
                {
                    "name": "Dance",
                    "degree": "BA",
                    "flag": "Auditions through the Department of Performing Arts SlideRoom portal.",
                    "flagSource": "checklist"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Data Sciences for Justice, Law and Criminology",
                    "degree": "BS"
                },
                {
                    "name": "Data Sciences for Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Early Childhood Education",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA or BS"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BA"
                },
                {
                    "name": "Engineering Physics",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "Finance",
                    "degree": "BS"
                },
                {
                    "name": "French Studies",
                    "degree": "BA"
                },
                {
                    "name": "German Studies",
                    "degree": "BA"
                },
                {
                    "name": "Global International Relations",
                    "degree": "BA"
                },
                {
                    "name": "Graphic and Visual Communication Design",
                    "degree": "BA"
                },
                {
                    "name": "Health Science",
                    "degree": "BS"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Studies: Communication, Legal Institutions, Economics, and Government (CLEG)",
                    "degree": "BA"
                },
                {
                    "name": "International Studies",
                    "degree": "BA"
                },
                {
                    "name": "Japanese Studies",
                    "degree": "BA"
                },
                {
                    "name": "Jewish Studies",
                    "degree": "BA"
                },
                {
                    "name": "Justice and Law",
                    "degree": "BA"
                },
                {
                    "name": "Language and Area Studies: French/Europe",
                    "degree": "BA"
                },
                {
                    "name": "Language and Area Studies: German/Europe",
                    "degree": "BA"
                },
                {
                    "name": "Language and Area Studies: Russian/Area Studies",
                    "degree": "BA"
                },
                {
                    "name": "Language and Area Studies: Spanish/Latin America",
                    "degree": "BA"
                },
                {
                    "name": "Legal Studies",
                    "degree": "BA"
                },
                {
                    "name": "Liberal Studies",
                    "degree": "BA"
                },
                {
                    "name": "Literature",
                    "degree": "BA"
                },
                {
                    "name": "Marketing",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and Economics",
                    "degree": "BS",
                    "note": "Offered through CAS/ECON and CAS/MATH"
                },
                {
                    "name": "Music",
                    "degree": "BA",
                    "flag": "Auditions through the Department of Performing Arts SlideRoom portal.",
                    "flagSource": "checklist"
                },
                {
                    "name": "Musical Theatre",
                    "degree": "BA",
                    "flag": "Auditions through the Department of Performing Arts SlideRoom portal.",
                    "flagSource": "checklist"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Photography",
                    "degree": "BA",
                    "note": "Offered through CAS/ART and SOC"
                },
                {
                    "name": "Physics",
                    "degree": "BA or BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Popular Music Performance and Enterprise",
                    "degree": "BA",
                    "flag": "Auditions through the Department of Performing Arts SlideRoom portal.",
                    "flagSource": "checklist"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Public Health",
                    "degree": "BA or BS"
                },
                {
                    "name": "Public Relations & Strategic Communication",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Russian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish Studies",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Studio Art",
                    "degree": "BA"
                },
                {
                    "name": "Theatre",
                    "degree": "BA",
                    "flag": "Auditions through the Department of Performing Arts SlideRoom portal.",
                    "flagSource": "checklist"
                },
                {
                    "name": "Women's, Gender, and Sexuality Studies",
                    "degree": "BA"
                }
            ]
        }
    ]
};

export default majors;
